import { Circle, Line, Path, Polyline, Rect, Svg } from '@react-pdf/renderer';

// Hand-ported from the lucide-react icons used on the interim one-pager's web page
// (InterimOnePager.tsx), so the PDF export can reuse the same glyphs — react-pdf can't
// render lucide-react components directly, only raw SVG primitives.
export type PdfIconProps = { size?: number; color?: string };

const commonStroke = {
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function MapPinIcon({ size = 12, color = '#FFFFFF' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" stroke={color} {...commonStroke} />
      <Circle cx={12} cy={10} r={3} stroke={color} {...commonStroke} />
    </Svg>
  );
}

export function Link2Icon({ size = 12, color = '#FFFFFF' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Path d="M9 17H7A5 5 0 0 1 7 7h2" stroke={color} {...commonStroke} />
      <Path d="M15 7h2a5 5 0 1 1 0 10h-2" stroke={color} {...commonStroke} />
      <Line x1={8} x2={16} y1={12} y2={12} stroke={color} {...commonStroke} />
    </Svg>
  );
}

export function FileTextIcon({ size = 12, color = '#FFFFFF' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" stroke={color} {...commonStroke} />
      <Path d="M14 2v4a2 2 0 0 0 2 2h4" stroke={color} {...commonStroke} />
      <Path d="M10 9H8" stroke={color} {...commonStroke} />
      <Path d="M16 13H8" stroke={color} {...commonStroke} />
      <Path d="M16 17H8" stroke={color} {...commonStroke} />
    </Svg>
  );
}

export function BookOpenIcon({ size = 14, color = '#4BABE0' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" stroke={color} {...commonStroke} />
      <Path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" stroke={color} {...commonStroke} />
    </Svg>
  );
}

export function CalendarIcon({ size = 12, color = '#2f7d5e' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Path d="M8 2v4" stroke={color} {...commonStroke} />
      <Path d="M16 2v4" stroke={color} {...commonStroke} />
      <Rect x={3} y={4} width={18} height={18} rx={2} stroke={color} {...commonStroke} />
      <Path d="M3 10h18" stroke={color} {...commonStroke} />
    </Svg>
  );
}

export function ClockIcon({ size = 10, color = '#2f7d5e' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Circle cx={12} cy={12} r={10} stroke={color} {...commonStroke} />
      <Polyline points="12 6 12 12 16 14" stroke={color} {...commonStroke} />
    </Svg>
  );
}

export function BriefcaseIcon({ size = 10, color = '#2f7d5e' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" stroke={color} {...commonStroke} />
      <Rect x={2} y={6} width={20} height={14} rx={2} stroke={color} {...commonStroke} />
    </Svg>
  );
}

export function DollarSignIcon({ size = 10, color = '#132543' }: PdfIconProps) {
  return (
    <Svg viewBox="0 0 24 24" width={size} height={size}>
      <Line x1={12} x2={12} y1={2} y2={22} stroke={color} {...commonStroke} />
      <Path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke={color} {...commonStroke} />
    </Svg>
  );
}
